<template>
  <div class="col-12">

    <div class="row">
      <div class="col-lg-6">
        <h4>لیست پاسخ های فرم: {{ form.name }}</h4>
      </div>
      <div class="col-lg-6 text-left">
        <router-link :to="{ name: 'Form' }" class="">
          <b-button pill class="px-5" variant="purple">فرم ها</b-button>
        </router-link>
      </div>
    </div>

    <form-table-items :items="items"/>

    <b-row class="pt-3 mt-3">
      <pagination :meta="pagination" :on-change-page="changeProductsPage"/>
    </b-row>
  </div>
</template>

<script>
import Pagination from "../Pagination.vue";
import FormTableItems from "./FormTableItems.vue";

export default {
  name: "FormFills",
  components: {FormTableItems, Pagination},
  data() {
    return {
      pagination: {},
      items: {},
      form: {}
    }
  },
  computed: {
    formId() {
      return this.$route.params.id
    }
  },
  methods: {
    changeProductsPage(page) {
      this.loadItems(page)
    },
    loadItems(page = 1) {
      let form = {
        form_id: this.formId,
        page: page
      }
      let req = this.$store.dispatch('Form/getFormFills', form)
      req.then(res => {
        let baseData = res.data.data;
        this.items = baseData.data
        this.pagination = baseData.meta
        this.form = baseData.form
      })
    }
  },
  mounted() {
    this.loadItems()
  }
}
</script>

<style scoped>

</style>